"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicLayoutEffect = void 0;
const react_1 = require("react");
const utils_1 = require("../../core/commons/utils");
exports.useIsomorphicLayoutEffect = (0, utils_1.isBrowser)()
    ? react_1.useLayoutEffect
    : react_1.useEffect;
//# sourceMappingURL=index.js.map